module.exports = __webpack_public_path__ + "img/gelf.eec77f6b.png";